import { render, staticRenderFns } from "./ClientStatus.vue?vue&type=template&id=ad0a01bc&scoped=true&"
import script from "./ClientStatus.vue?vue&type=script&lang=ts&"
export * from "./ClientStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ClientStatus.vue?vue&type=style&index=0&id=ad0a01bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0a01bc",
  null
  
)

export default component.exports